export default __webpack_public_path__ + "static/media/x-ray.a35b162f.jpg";